import { giphyCharcoal } from '@giphy/colors'
import { IconComponent } from 'ui'
import { Subheading, Toolbar } from '../style'
import Grid from './grid'
import { Filters, Wrapper } from './style'

type Props = {
    className?: string
}

const UGEFiltersEditor = ({ className }: Props) => {
    return (
        <div className={className}>
            <Toolbar>
                <Subheading>
                    <IconComponent color={giphyCharcoal} icon="filter" height={18} width={18} />
                    Filters
                </Subheading>
            </Toolbar>
            <Wrapper>
                <Filters>
                    <Grid />
                </Filters>
            </Wrapper>
        </div>
    )
}

export default UGEFiltersEditor
